import { useState } from "react"

export const useToggle = (initialState: boolean) => 
{
    const [val, set] = useState(initialState);
    const open = () => set(true);
    const close = () => set(false);
    const toggle = () => set(!val);
    return { isOpen: val, open, close, set, toggle };
}